import { h } from 'vue'

export default {
  name: 'DragHelper',
  emits: ['dragstart', 'drag', 'dragend'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.handleMouseMoveBound = this.handleMouseMove.bind(this)
    this.handleMouseUpBound = this.handleMouseUp.bind(this)
    this.handleTouchMoveBound = this.handleTouchMove.bind(this)
    this.handleTouchEndBound = this.handleTouchEnd.bind(this)
    this.$el.addEventListener('mousedown', this.handleMouseDown)
    this.$el.addEventListener('touchstart', this.handleTouchStart, {
      passive: false
    })
  },
  beforeUnmount() {
    this.$el.removeEventListener('mousedown', this.handleMouseDown)
    this.$el.removeEventListener('touchstart', this.handleTouchStart)
    document.removeEventListener('mousemove', this.handleMouseMoveBound)
    document.removeEventListener('mouseup', this.handleMouseUpBound)
    document.removeEventListener('touchmove', this.handleTouchMoveBound)
    document.removeEventListener('touchend', this.handleTouchEndBound)
  },
  methods: {
    handleMouseDown(e) {
      e.preventDefault()
      if (this.disabled) return
      this.startDrag(e.pageX)
      this.hasMoved = false
      document.addEventListener('mousemove', this.handleMouseMoveBound)
      document.addEventListener('mouseup', this.handleMouseUpBound)
    },
    handleTouchStart(e) {
      if (this.disabled) return
      e.preventDefault()
      const touch = e.touches[0]
      this.startDrag(touch.pageX)
      this.hasMoved = false
      document.addEventListener('touchmove', this.handleTouchMoveBound)
      document.addEventListener('touchend', this.handleTouchEndBound)
    },
    handleMouseMove(e) {
      this.hasMoved = true
      this.drag(e.pageX)
    },
    handleTouchMove(e) {
      this.hasMoved = true
      const touch = e.touches[0]
      this.drag(touch.pageX)
    },
    handleMouseUp(e) {
      // Als er niet gesleept is, behandel het als een klik op de balk
      if (!this.hasMoved) {
        const offsetX = e.pageX - this.offsetLeft
        const width = this.$el.offsetWidth
        const clampedOffsetX = Math.max(0, Math.min(offsetX, width))
        this.$emit('drag', { offsetX: clampedOffsetX })
      }
      this.endDrag()
      document.removeEventListener('mousemove', this.handleMouseMoveBound)
      document.removeEventListener('mouseup', this.handleMouseUpBound)
    },
    handleTouchEnd(e) {
      // Als er niet gesleept is, behandel het als een tap op de balk
      if (!this.hasMoved && e.changedTouches) {
        const touch = e.changedTouches[0]
        const offsetX = touch.pageX - this.offsetLeft
        const width = this.$el.offsetWidth
        const clampedOffsetX = Math.max(0, Math.min(offsetX, width))
        this.$emit('drag', { offsetX: clampedOffsetX })
      }
      this.endDrag()
      document.removeEventListener('touchmove', this.handleTouchMoveBound)
      document.removeEventListener('touchend', this.handleTouchEndBound)
    },
    startDrag(startX) {
      const { left } = this.$el.getBoundingClientRect()
      this.startX = startX
      this.offsetLeft = left
      this.$emit('dragstart')
    },
    drag(currentX) {
      const offsetX = currentX - this.offsetLeft
      const width = this.$el.offsetWidth
      const clampedOffsetX = Math.max(0, Math.min(offsetX, width))
      this.$emit('drag', { offsetX: clampedOffsetX })
    },
    endDrag() {
      this.$emit('dragend')
    }
  },
  render() {
    return h(
      'span',
      {
        onMousedown: this.handleMouseDown,
        onTouchstart: this.handleTouchStart
      },
      this.$slots.default()
    )
  }
}
